import React, { useEffect, useState } from 'react';
import { v4 as uuidv4 } from 'uuid';
import '../Styles/CursorEffect.css';

const CursorEffect = () => {
  const [positions, setPositions] = useState([]);
  const intervalRef = React.useRef(null);  // Step 1


    useEffect(() => {
        const addStar = (e) => {
            const newStars = Array.from({ length: 1 }).map((_, idx) => {
                const dx = Math.random() * 10 * (Math.random() > 0.5 ? 1 : -1);
                const dy = Math.random() * 10 * (Math.random() > 0.5 ? 1 : -1);
                return {
                    x: e.clientX + dx,
                    y: e.clientY + dy,
                    dx,
                    dy,
                    id: uuidv4(),
                    delay: idx * 0.1
                };
            });
            setPositions((prev) => [...prev, ...newStars]);
            setTimeout(() => {
                setPositions((prev) => prev.filter((star) => !newStars.find(s => s.id === star.id)));
            }, 1500);
        };

        window.addEventListener('mousemove', addStar);
        return () => {
            window.removeEventListener('mousemove', addStar);
        };
    }, []);

    return (
        <div className="cursor-effect-container">
            {positions.map((pos) => (
                <div
                key={pos.id}
                className="star"
                style={{ 
                    left: `${pos.x}px`, 
                    top: `${pos.y}px`,
                    animationDelay: `${pos.delay}s`,
                    animationName: `fadeNscale, ${Math.abs(pos.dx) < 3 ? 'widenCenter' : (Math.sign(pos.dx) > 0 ? 'widenRight' : 'widenLeft')}`
                }}
            >
                ★
            </div>
            ))}
        </div>
    );
};

export default CursorEffect;
//  ★
// 🍌